// extracted by mini-css-extract-plugin
export default {"chat":"Comment_chat__SQkmS","chatAuthor":"Comment_chatAuthor__l0d2f","mobileHeight":"Comment_mobileHeight__jnICH","input":"Comment_input__ITZay"};